import clsx from 'clsx';
import { UseFormRegisterReturn } from 'react-hook-form';

import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

type InputFieldProps = FieldWrapperPassThroughProps & {
  type?: 'text' | 'email' | 'password' | 'date' | 'number';
  disabled?: boolean;
  className?: string;
  registration: Partial<UseFormRegisterReturn>;
};

export const InputField = (props: InputFieldProps) => {
  const { type = 'text', disabled, label, className, registration, error, helperText } = props;
  return (
    <FieldWrapper label={label} error={error} helperText={helperText}>
      <input
        disabled={disabled}
        type={type}
        className={clsx(
          'block w-full appearance-none bg-white',
          'rounded-3xl border border-gray-300',
          'px-3 py-2 placeholder-gray-400 shadow-sm',
          'focus:border-dodger-blue-600 focus:ring-dodger-blue-600',
          'disabled:bg-ebony-clay-50 sm:text-sm',
          className
        )}
        {...registration}
      />
    </FieldWrapper>
  );
};
